import React, { useRef, useState } from "react";

import { ExpandState, IconName } from "../types";
import Icon from "./Icon";

// @ts-ignore
let timeoutRef = null;
const Collapsable = (props: {
  titleContent: JSX.Element;
  expandContent: JSX.Element;
  disabled?: boolean;
  additionalClasses?: string;
  startExpanded?: boolean;
}) => {
  const [expandState, setExpandState] =
    useState<ExpandState>(props.startExpanded ? "state-expanded" : "state-collapsed");
  const [expandToHeight, setExpandToHeight] = useState(0);
  const contentInnerRef = useRef<HTMLDivElement>(null);

  const onClickHeader = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (props.disabled) {
      return;
    }

    if (contentInnerRef.current) {
      // @ts-ignore
      clearTimeout(timeoutRef);

      let targetState: ExpandState = "state-expanded";
      if (
        expandState === "state-expanded" ||
        expandState === "state-expanding"
      ) {
        targetState = "state-collapsed";
      }
      if (targetState === "state-expanded") {
        setExpandToHeight(
          contentInnerRef.current.getBoundingClientRect().height
        );
        setExpandState("state-expanding");
      } else {
        setExpandState("state-collapsing");
        requestAnimationFrame(() => {
          setExpandToHeight(0);
        });
      }

      timeoutRef = setTimeout(function () {
        setExpandState(targetState);
      }, 700);
    }
  };

  return (
    <div className={`pyht-collapsable ${props.additionalClasses ? props.additionalClasses : ""}`}>
      <div className={"header"} role={"button"} onClick={onClickHeader}>
        <>
          <Icon
            name={IconName.CHEVRON_DOWN}
            className={`direction-icon ${expandState}`}
          />
          {props.titleContent}
        </>
      </div>
      <div
        className={`content copy ${expandState}`}
        style={{ height: `${expandToHeight}px` }}
      >
        <div className={"inner"} ref={contentInnerRef}>
          {props.expandContent}
        </div>
      </div>
    </div>
  );
};

export default Collapsable;
